import React from 'react'
import Callfrom from './Callfrom'
import Contactform from './Contactfrom';
function Callback() {
  const phoneNumber = "918101278298"; // Replace with your number (with country code, no +)
  const message = "Hello, I am interested in your services!";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918101278298}?text=${encodedMessage}`;
  return (
    <div>
      <div className='officeshiftingsouthkolkata'>
        <br />
        <div className="album py-1">
          <div className="container">
            <center>
              <h3 className='mb-3'><b>Get a Call Back Instantly</b></h3>
            </center>
            <p>AT India Packer is the best packers and movers in India. We are renowned for providing exceptional relocation services both within India and internationally. Our team of expert packers and movers brings years of experience in delivering high-quality packing and moving solutions across the country.</p>
            <div className="row">
              <div className="col-md-6 mt-3 me-5">
                <Callfrom />
                <br />

              </div>
              <div className="col-md-5 mt-3">
                <center><p>Speak to us on Call :</p>

                  <h2><b><a className='mb-3' style={{ color: "#05438e" }} href='tel: 7551001003'> Call: +91 755-100-100-3</a></b></h2>
                </center>
                <center>
                  <div className="d-flex justify-content-between align-items-center mb-2">

                    <button type="button" className="whatsapp mt-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      GET A QOUTE
                    </button>

                    <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title packersmoverswebsite" id="exampleModalLabel">AT INDIA PACKERS</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className="modal-body">
                            <Callfrom/>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="close" data-bs-dismiss="modal">Close</button>

                          </div>
                        </div>
                      </div>
                    </div>
                    <button className='whatsapp mt-2'>   <a style={{ color: "white" }} href={whatsappURL} target="_blank" rel="noopener noreferrer">WhatsApp</a></button>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Callback